// @flow
import { useMemo } from 'react';
import { filter, when, always, propEq, sortWith, descend, prop } from 'ramda';

import type { OrderRequest } from '../../dataTypes/orderRequests/OrderRequest.types';
import { statuses, type Status } from '../../dataTypes/orderRequests/statuses';


export default function useItemsFiltered(
  rawItems: Array<OrderRequest>,
  currentStatus: Status,
): Array<OrderRequest> {
  const actual = useMemo(() => {
    return sortWith([
      descend(prop('date')),
      descend(prop('id')),
    ], rawItems);
  }, [rawItems]);

  const res = useMemo(() => {
    return when(
      always(currentStatus !== statuses.All),
      filter(propEq('status', currentStatus)),
      actual,
    );
  }, [actual, currentStatus]);

  return res;
}
